export const SEQUENCES_PER_PAGE = 6;

export const BUSINESS_PER_SCROLL = 20;
